export class Subscriptions {
    onCreateTeamSubscription = `subscription onCreateTeam {
        onCreateTeam {
          team_id
          team_name
        }
      } `;

    userResponseSubscription = `subscription onCreateWorkshopUserResponse{
        onCreateWorkshopUserResponse{
          data
        }
    }`;
}
